<template>
  <div>
    <h3 class="text-muted mb-4">Export</h3>
    <div class="w-100">
      <a-radio-group v-model="actionType">
        <a-radio
          v-if="selectedActions.includes('Send')"
          :style="radioStyle"
          value="SEND"
        >
          Send to email
        </a-radio>
        <a-radio
          v-if="selectedActions.includes('Download')"
          :style="radioStyle"
          value="DOWNLOAD"
        >
          Download
        </a-radio>
      </a-radio-group>
    </div>
    <div
      v-if="selectedActions.includes('Send') && actionType == 'SEND'"
      class="w-100"
      style="position: absolute; bottom: 4em; right: 0px; padding: 10px"
    >
      <div class="mt-auto p-2">
        Note: The data will be sent to your registered email address.
      </div>
    </div>

    <div
      class="w-100 border"
      style="position: absolute; bottom: 0px; right: 0px; padding: 10px"
    >
      <div class="d-flex justify-content-between">
        <div class="col-auto">
          <a-button
            type="secondary"
            :loading="submitLoading"
            @click.prevent="closeDrawer"
          >
            Cancel
          </a-button>
        </div>

        <div
          v-if="
            actionType == 'DOWNLOAD' && selectedActions.includes('Download')
          "
          class="col-auto"
        >
          <a-spin :spinning="exporting">
            <a-button
              v-if="type == 'xls'"
              type="primary"
              class="btn-sm"
              :loading="exporting"
              @click="downloadAsExcel"
            >
              Export
            </a-button>
            <downloadexcel
              v-else
              class="btn btn-primary btn-sm"
              :fields="jsonFields"
              :escapeCsv="false"
              :before-generate="beforeGenerate"
              :before-finish="beforeFinish"
              :type="fileType"
              :name="filename"
              :fetch="
                () => {
                  return fetchJsonData();
                }
              "
            >
              <span>Export</span>
            </downloadexcel>
          </a-spin>
        </div>
        <div v-else class="col-auto">
          <base-button
            type="primary btn-block"
            class="btn-sm"
            :loading="submitLoading"
            @click.prevent="confirmExport"
          >
            <div>Submit</div>
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import downloadexcel from 'vue-json-excel';
import * as XLSX from 'xlsx';
import secureStorage from '@/controllers/secureStorage';
import { mapGetters } from 'vuex';

export default {
  name: 'ExportDataForm',
  components: {
    downloadexcel
  },
  props: {
    apiUrl: String,
    filename: String,
    type: String,
    jsonFields: Object,
    template: String,
    from: {
      type: String,
      default: null
    },
    reportType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      submitLoading: false,
      actionType: 'SEND',
      exporting: false,
      fileType: 'csv',
      exportSelection: 'all',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      formData: {
        url: null
      }
    };
  },
  methods: {
    beforeGenerate() {
      this.$notification.success({
        message: 'Fetching data'
      });
      this.exporting = true;
    },
    beforeFinish() {
      this.$notification.success({
        message: 'Data Generated'
      });
      this.exporting = false;

      setTimeout(() => this.$emit('closeDrawer', null), 200);
    },
    async fetchJsonData() {
      let isFullUrl = /^(http|https):\/\//i.test(this.apiUrl);
      if (!isFullUrl) {
        let fullUrl = new URL(this.apiUrl, window.location.origin);
        let params = new URLSearchParams(fullUrl.search);
        params.delete('source');
        let cleanedUrl = fullUrl.pathname + '?' + params.toString();
        this.apiUrl = cleanedUrl.replace(
          /(\?&+)|(\?+)|(&+)+/g,
          function (match, p1, p2, p3) {
            if (p1) return '?';
            if (p2) return '?';
            if (p3) return '&';
          }
        );
      }
      if (this.type == 'xls') {
        this.fileType = 'xls';
      }
      const response = await HTTPRequest.getRequest(this.apiUrl);

      if (this.from === 'auditLogsReport' && Array.isArray(response)) {
        const monthNames = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ];

        const getDatePart = (value, part) => {
          if (typeof value !== 'string') return value;

          const [year, month, day] = value.split('-');
          if (!year || !month || !day) return value;

          if (part === 'birth_month') {
            const monthIndex = Number(month) - 1;
            return monthNames[monthIndex]
              ? `${month} - ${monthNames[monthIndex]}`
              : value;
          }

          if (part === 'birth_year') return year;
          if (part === 'birth_day') return day;

          return value;
        };

        return response.map((item) => {
          const formattedItem = { ...item };

          if ('birth_month' in formattedItem) {
            formattedItem.birth_month = getDatePart(
              formattedItem.birth_month,
              'birth_month'
            );
          }

          if ('birth_year' in formattedItem) {
            formattedItem.birth_year = getDatePart(
              formattedItem.birth_year,
              'birth_year'
            );
          }

          if ('birth_day' in formattedItem) {
            formattedItem.birth_day = getDatePart(
              formattedItem.birth_day,
              'birth_day'
            );
          }

          return formattedItem;
        });
      }

      return response;
    },
    async downloadAsExcel() {
      this.beforeGenerate();
      try {
        const response = await this.fetchJsonData();
        const data = Array.isArray(response) ? response : [];

        // Prepare data with correct headers
        const excelData = data.map((item) => {
          const row = {};
          for (const [header, field] of Object.entries(this.jsonFields)) {
            let value;
            if (typeof field === 'object' && field.callback) {
              value = field.callback(item[field.field]);
            } else {
              value = item[field];
            }

            // Ensure Mobile Number is treated as string
            if (
              header === 'Mobile Number' ||
              field === 'mobile_no' ||
              (typeof field === 'object' && field.field === 'mobile_no')
            ) {
              value = value != null ? String(value) : '';
            }

            row[header] = value;
          }
          return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Apply cell formatting for amount_gross and Mobile Number
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const cols = [];

        for (let C = range.s.c; C <= range.e.c; ++C) {
          const address = XLSX.utils.encode_col(C) + '1';
          const header = worksheet[address]?.v;

          // Find if this header corresponds to amount_gross, Mobile Number, or other string fields
          let isGrossAmount = false;
          let isTotalPurchase = false;
          let isTotalPoints = false;
          let isMobileNumber = false;
          let isStringField = false;
          for (const [h, f] of Object.entries(this.jsonFields)) {
            if (h === header) {
              if (
                f === 'amount_gross' ||
                (typeof f === 'object' && f.field === 'amount_gross')
              ) {
                isGrossAmount = true;
              }
              if (
                f === 'total_purchase' ||
                (typeof f === 'object' && f.field === 'total_purchase')
              ) {
                isTotalPurchase = true;
              }
              if (
                f === 'total_points' ||
                f === 'total_expired_points' ||
                (typeof f === 'object' &&
                  (f.field === 'total_points' ||
                    f.field === 'total_expired_points'))
              ) {
                isTotalPoints = true;
              }
              if (
                f === 'mobile_no' ||
                h === 'Mobile Number' ||
                (typeof f === 'object' && f.field === 'mobile_no')
              ) {
                isMobileNumber = true;
              }
              if (
                [
                  'transaction_id',
                  'terminal_code',
                  'card_number',
                  'membership_number'
                ].includes(f) ||
                (typeof f === 'object' &&
                  ['transaction_id', 'terminal_code', 'card_number'].includes(
                    f.field
                  ))
              ) {
                isStringField = true;
              }
              break;
            }
          }

          if (isGrossAmount) {
            cols[C] = { z: '#,##0.00' };
            for (let R = range.s.r + 1; R <= range.e.r; ++R) {
              const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              // Ensure value is a number
              const val = parseFloat(cell.v);
              if (!isNaN(val)) {
                cell.t = 'n';
                cell.v = val;
                cell.z = '#,##0.00';
              }
            }
          }

          if (isTotalPurchase) {
            cols[C] = { z: '#,##0.00' };
            for (let R = range.s.r + 1; R <= range.e.r; ++R) {
              const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              const strVal = String(cell.v).replace(/,/g, '');
              const val = parseFloat(strVal);
              if (!isNaN(val)) {
                cell.t = 'n';
                cell.v = val;
                cell.z = '#,##0.00';
              }
            }
          }

          if (isTotalPoints) {
            cols[C] = { z: '#,##0' };
            for (let R = range.s.r + 1; R <= range.e.r; ++R) {
              const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              const strVal = String(cell.v).replace(/,/g, '');
              const val = parseFloat(strVal);
              if (!isNaN(val)) {
                cell.t = 'n';
                cell.v = val;
                cell.z = '#,##0';
              }
            }
          }

          if (isMobileNumber || isStringField) {
            cols[C] = { z: '@' };
            for (let R = range.s.r + 1; R <= range.e.r; ++R) {
              const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
              const cell = worksheet[cellAddress];
              if (!cell) continue;

              cell.t = 's';
              cell.z = '@';
              // Ensure value is treated as string and NOT a number
              if (cell.v !== undefined && cell.v !== null) {
                let val = String(cell.v);
                // Strip vue-json-excel formula workaround if present (e.g., ="123")
                if (val.startsWith('="') && val.endsWith('"')) {
                  val = val.substring(2, val.length - 1);
                }
                cell.v = val;
              }
            }
          }
        }

        worksheet['!cols'] = cols;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

        const fileName = this.filename || 'Export.xlsx';
        XLSX.writeFile(workbook, fileName);

        this.beforeFinish();
      } catch (error) {
        console.error('Export failed:', error);
        this.$notification.error({
          message: 'Export failed'
        });
        this.exporting = false;
      }
    },
    closeDrawer() {
      this.$emit('closeDrawer', null);
    },
    async confirmExport() {
      this.submitLoading = true;
      this.formData.url = this.apiUrl;
      this.formData.report_template_id = this.template;

      const response = await HTTPRequest.postRequest(
        '/api/v1/email_reports_queue?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        {
          export: this.formData
        }
      );

      if (response.id) {
        this.$notification.success({
          message: 'Successfully added to the email queue.'
        });
        this.$emit('closeDrawer', null);
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
      this.submitLoading = false;
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  }
};
</script>

<style scoped></style>
